module.exports = __webpack_public_path__ + "img/main-gallery1-mob.9b52d742.jpg";